(function () {
  'use strict';
  if (window.efBuilderHook && window.efBuilderHook.efx) return;
  document.documentElement.classList.add('efx-js');

  var UA = navigator.userAgent || '';
  var IN_APP = !!window.EFX_TEST_INAPP || /FBAN|FBAV|FB_IAB|FBIOS|FB4A|Instagram|Messenger|LinkedInApp|Snapchat|musical_ly|TikTok|Line\/|Pinterest/i.test(UA);
  var ANDROID = /Android/i.test(UA);
  var PARAM = 'efdesign';
  var PDF_BUSY = 'Preparing your PDF\u2026';
  var SEND_BUSY = 'Sending configuration\u2026';
  var SENT_KEY = 'efx-sent-v1';
  var NATIVE_KEY = 'efx-native-send';

  function settings() { return window.EFX_SETTINGS || {}; }
  function warn(error) { try { console.warn('[EF builder extras]', error); } catch (_) {} }
  function has(root, name) { return !!(root && root.classList && root.classList.contains(name)); }
  function list(root, selector) { return Array.prototype.slice.call(root.querySelectorAll(selector)); }
  function str(value, max) { return typeof value === 'string' ? value.slice(0, max || 120) : ''; }
  function stored(area, key) { try { return JSON.parse(window[area].getItem(key) || 'null'); } catch (_) { return null; } }
  function store(area, key, value) {
    try { if (value === null) window[area].removeItem(key); else window[area].setItem(key, JSON.stringify(value)); } catch (_) {}
  }

  function track(name, params) {
    if (settings().analytics === false) return;
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (_) {}
  }

  /* ---------- page preparation (runs before the builder is constructed) ---------- */

  function targetWidth() {
    var vw = Math.min(window.innerWidth || 1200, (window.screen && window.screen.width) || 99999);
    var dpr = Math.min(window.devicePixelRatio || 1, 3);
    return Math.max(800, Math.min(2600, Math.ceil((Math.max(320, vw) * dpr) / 200) * 200));
  }

  function resizeImages(root) {
    var width = targetWidth();
    if (width >= 2600) return;
    list(root, '[data-model-input], [data-preview-panel]').forEach(function (element) {
      Object.keys(element.dataset).forEach(function (key) {
        if (!/^(preview|image|cardImage|generic|efMask|classicMask|checkerMask)/.test(key)) return;
        var value = element.dataset[key];
        if (!value || value.indexOf('width=') < 0) return;
        var next = value.replace(/([?&]width=)(\d+)/, function (all, prefix, size) {
          return Number(size) > width ? prefix + width : all;
        });
        if (next !== value) element.dataset[key] = next;
      });
    });
  }

  function efPatternInput(root) {
    var panel = root.querySelector('[data-preview-panel]');
    var label = panel && panel.dataset.efLabel;
    return list(root, 'input[data-group="colourDesign"][data-key="pattern"]').filter(function (input) {
      return label ? input.value === label : /^ef\b/i.test(input.value);
    })[0] || null;
  }

  function markupHasInteriorAssets(root) {
    var found = false;
    list(root, '[data-model-input]').forEach(function (input) {
      if (input.dataset.previewInteriorBase || input.dataset.previewInteriorPlaceholder) found = true;
    });
    list(root, '[data-interior-preview-panel]').forEach(function (panel) {
      if (panel.dataset.interiorBase || panel.dataset.interiorPlaceholder) found = true;
    });
    return found;
  }

  function arrangeSingle(root, s) {
    var colours = root.querySelector('[data-config-section="colours"]');
    if (!colours || colours.querySelector('.efx-intro')) return;
    if (s.tidyCopy === false) {
    var intro = document.createElement('div');
    intro.className = 'efx-intro';
    if (s.eyebrow) {
      var eyebrow = document.createElement('p');
      eyebrow.className = 'efx-intro__eyebrow';
      eyebrow.textContent = s.eyebrow;
      intro.appendChild(eyebrow);
    }
    if (s.intro) {
      var text = document.createElement('p');
      text.className = 'efx-intro__text';
      text.textContent = s.intro;
      intro.appendChild(text);
    }
    if (intro.childNodes.length) colours.insertBefore(intro, colours.firstChild);
    }
    var heading = colours.querySelector(':scope > .ef-section-heading');
    var mobile = colours.querySelector(':scope > .ef-mobile-preview');
    if (heading && mobile) colours.insertBefore(mobile, heading);
    var help = root.querySelector('[data-config-section="model"] .ef-included-message');
    var disclaimer = colours.querySelector('.ef-disclaimer');
  }

  function prepare(root) {
    var s = settings();
    if (s.mobileImages !== false) resizeImages(root);
    if (s.metallic !== false) { try { applyCombos(root, s, applyPalette(root, s)); applyExterior(root); } catch (error) { warn(error); } }
    if (s.interiorPreview !== false) { try { applyInterior(root); } catch (error) { warn(error); } }
    var models = list(root, '[data-model-input]');
    var single = s.singleFloat !== false && models.length === 1;
    var model = single ? models[0] : null;
    var skipPattern = !!(model && efPatternInput(root) && model.dataset.previewEfBase && model.dataset.previewEf1 && !model.dataset.previewClassicBase);
    root.classList.add('efx');
    root.classList.toggle('efx-single', single);
    root.classList.toggle('efx-skip-pattern', skipPattern);
    root.classList.toggle('efx-no-interior', !markupHasInteriorAssets(root));
    root.classList.toggle('efx-inapp', IN_APP);
    root.classList.toggle('efx-scroll-title', s.scrollTitle !== false);
    if (s.tidyCopy !== false) { try { tidyCopy(root); } catch (error) { warn(error); } }
    if (single) arrangeSingle(root, s);
    if (s.reliableSend !== false) installSubmitProxy(root);
    privacyLine(root, s);
    polishCombos(root);
    setupPreviewToggles(root);
  }

  /* ---------- v5: shorter, easier headings and helper text ---------- */

  function shortName(name) {
    var text = String(name || '').replace(/^Pearl\s+/i, '');
    return text ? text.charAt(0).toUpperCase() + text.slice(1) : String(name || '');
  }

  function noStop(text) { return String(text || '').replace(/\s+/g, ' ').trim().replace(/\.$/, ''); }

  var SECTION_TEXT = {
    colours: '',
    package: 'The package sets the access door, caravan window and living appliances.',
    setup: 'Options that don’t suit your float are removed automatically.',
    interior: '',
    review: 'Check your build, then add your details so we can confirm it.'
  };
  var SUBTITLES = {
    'Choose the finishes available for your range': 'Choose your finishes',
    'This controls the finish only. Inclusion depends on the selected range and package': 'Finish only – inclusion depends on your package',
    'Select the direction the horse bays face when viewed from the rear': 'Which way the horses face, seen from the rear',
    'Final compatibility is confirmed against the selected float range': 'We confirm it suits your float',
    'Choose whether fold-up beds are required where compatible': 'Where your float allows them'
  };

  function tidyHeading(element, title, sub) {
    var strong = element.querySelector(':scope > strong');
    var span = element.querySelector(':scope > span');
    if (!strong || !span) return;
    strong.textContent = title;
    span.textContent = SUBTITLES[sub] || sub;
    element.classList.add('efx-head');
    strong.classList.add('efx-head__title');
    span.classList.add('efx-head__sub');
    span.hidden = !span.textContent;
  }

  function tidyCopy(root) {
    list(root, '[data-config-section] :is(h2, h3)').forEach(function (heading) {
      var strong = heading.querySelector(':scope > strong');
      var span = heading.querySelector(':scope > span');
      if (strong && span) tidyHeading(heading, noStop(strong.textContent), noStop(span.textContent));
    });
    list(root, '[data-config-section] legend:not(.visually-hidden)').forEach(function (legend) {
      var strong = legend.querySelector(':scope > strong');
      var span = legend.querySelector(':scope > span');
      if (!strong || !span) return;
      var parts = noStop(strong.textContent).split(/\.\s+/);
      if (parts.length > 1) tidyHeading(legend, parts[0], noStop(parts.slice(1).join('. ')));
      else tidyHeading(legend, parts[0], noStop(span.textContent));
    });
    list(root, '[data-config-section] .ef-section-heading > p').forEach(function (paragraph) {
      var name = paragraph.closest('[data-config-section]').dataset.configSection;
      if (!Object.prototype.hasOwnProperty.call(SECTION_TEXT, name)) return;
      if (SECTION_TEXT[name]) paragraph.textContent = SECTION_TEXT[name];
      else paragraph.classList.add('efx-hide');
    });
  }

  /* ---------- popular combinations: compact two-line chips ---------- */

  function polishCombos(root) {
    list(root, '.ef-combination[data-combination]').forEach(function (button) {
      if (button.querySelector('.efx-combo__names')) return;
      var parts = String(button.dataset.combination || '').split('|').map(function (part) { return part.trim(); });
      var label = button.querySelector(':scope > span:last-child');
      if (!label || parts.length !== 2 || !parts[0] || !parts[1]) return;
      label.className = 'efx-combo__names';
      button.title = shortName(parts[0]) + ' + ' + shortName(parts[1]);
      label.textContent = '';
      [['efx-combo__a', shortName(parts[0])], ['efx-combo__b', shortName(parts[1])]].forEach(function (pair) {
        var line = document.createElement('span');
        line.className = pair[0];
        line.textContent = pair[1];
        label.appendChild(line);
      });
      var check = document.createElement('span');
      check.className = 'efx-combo__check';
      check.setAttribute('aria-hidden', 'true');
      check.innerHTML = '<svg viewBox="0 0 16 16" width="10" height="10" focusable="false"><path d="M3.5 8.5l3 3 6-7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      button.insertBefore(check, button.firstChild);
    });
  }

  /* ---------- v4: metallic RAL palette and Overnighter interior finishes ---------- */

  var FILES = '/cdn/shop/files/';
  var SPRITE = 'efx-swatches-v2.jpg';
  var SPRITE_KEYS = ["metal:9016", "metal:9006", "metal:9007", "metal:9022", "metal:7048", "metal:9023", "metal:1035", "metal:1036", "metal:2013", "metal:8029", "metal:3032", "metal:3033", "metal:3015", "metal:4011", "metal:4012", "metal:230 80 15", "metal:5025", "metal:5026", "metal:6035", "metal:6036", "floor:WC32302", "floor:WC32501", "floor:PAL0881-05", "cabinetry:Bright White", "cabinetry:Charcoal", "benchtop:5460", "benchtop:7408", "benchtop:8833", "upholstery:1", "upholstery:2", "upholstery:3", "upholstery:4", "upholstery:5", "upholstery:6", "upholstery:7", "upholstery:8", "upholstery:9", "upholstery:10", "upholstery:11", "upholstery:12", "upholstery:13", "upholstery:14", "upholstery:15", "upholstery:16", "upholstery:17", "upholstery:18"];
  var ART = 'ef_two-horse-angle-load_';
  var METAL_VER = '-v3';
  var metalModels = [];

  function spriteBg(element, key) {
    var index = SPRITE_KEYS.indexOf(key);
    if (!element || index < 0) return;
    element.style.backgroundImage = 'url("' + FILES + SPRITE + '")';
    element.style.backgroundSize = '900% 600%';
    element.style.backgroundPosition = ((index % 9) * 12.5) + '% ' + (Math.floor(index / 9) * 20) + '%';
    element.classList.add('efx-chip');
  }

  function paletteList(s) {
    return String(s.palette || '').split(/\r?\n/).map(function (line) {
      var parts = line.split('|').map(function (part) { return part.trim(); });
      if (parts.length < 3 || !parts[1] || !/^#[0-9a-f]{6}$/i.test(parts[2])) return null;
      var code = parts[0].replace(/^RAL\s*/i, '');
      return { code: code, ral: 'RAL ' + code, name: parts[1], hex: parts[2].toLowerCase() };
    }).filter(Boolean);
  }

  // The PDF canvas is sized from the base layer, so each render is requested at the same width.
  function exteriorWidth() {
    if (settings().mobileImages === false) return 0;
    var width = targetWidth();
    return width < 1800 ? width : 0;
  }

  function metalUrl(code) {
    var width = exteriorWidth();
    return FILES + 'efx-metal-' + String(code).replace(/\s+/g, '-') + METAL_VER + '.jpg' + (width ? '?width=' + width : '');
  }

  function swapText(root, from, to) {
    if (!from || from === to) return;
    list(root, '*').forEach(function (element) {
      if (!element.children.length && element.textContent.trim() === from) element.textContent = to;
    });
  }

  function applyPalette(root, s) {
    var palette = paletteList(s);
    if (!palette.length) return [];
    ['colour1', 'colour2'].forEach(function (slot) {
      var buttons = list(root, '[data-colour-option][data-colour-target="' + slot + '"]');
      if (!buttons.length) return;
      var template = buttons[0];
      var label = slot === 'colour1' ? 'Colour 1' : 'Colour 2';
      var fragment = document.createDocumentFragment();
      palette.forEach(function (colour) {
        var button = template.cloneNode(true);
        button.dataset.name = colour.name;
        button.dataset.ral = colour.ral;
        button.dataset.hex = colour.hex;
        button.dataset.texture = metalUrl(colour.code);
        button.setAttribute('aria-label', 'Use ' + colour.name + ', ' + colour.ral + ' as ' + label);
        button.setAttribute('aria-pressed', 'false');
        button.classList.remove('is-selected', 'is-active');
        swapText(button, template.dataset.name, colour.name);
        swapText(button, template.dataset.ral, colour.ral);
        var circle = button.querySelector('.ef-swatch__circle');
        if (circle) { circle.style.setProperty('--ef-swatch', colour.hex); spriteBg(circle, 'metal:' + colour.code); }
        fragment.appendChild(button);
      });
      template.parentNode.insertBefore(fragment, template);
      buttons.forEach(function (button) { button.remove(); });
    });
    return palette;
  }

  function applyCombos(root, s, palette) {
    var buttons = list(root, '.ef-combination[data-combination]');
    if (!buttons.length || !palette.length) return;
    var byName = {};
    palette.forEach(function (colour) { byName[colour.name.toLowerCase()] = colour; });
    var template = buttons[0];
    var fragment = document.createDocumentFragment();
    String(s.combos || '').split(/\r?\n/).forEach(function (line) {
      var parts = line.split('|').map(function (part) { return part.trim().toLowerCase(); });
      var a = byName[parts[0]];
      var b = byName[parts[1]];
      if (!a || !b) return;
      var button = template.cloneNode(true);
      button.dataset.combination = a.name + '|' + b.name;
      button.setAttribute('aria-label', 'Apply ' + a.name + ' and ' + b.name);
      button.classList.remove('is-selected');
      var dots = list(button, '.ef-combination__pair i');
      [a, b].forEach(function (colour, index) {
        if (!dots[index]) return;
        dots[index].style.setProperty('--ef-combo', colour.hex);
        spriteBg(dots[index], 'metal:' + colour.code);
      });
      var label = button.querySelector(':scope > span:last-child');
      if (label) label.textContent = a.name + ' + ' + b.name;
      fragment.appendChild(button);
    });
    if (!fragment.childNodes.length) return;
    template.parentNode.insertBefore(fragment, template);
    buttons.forEach(function (button) { button.remove(); });
  }

  // Metallic renders line up with the Two-Horse Angle Load artwork only.
  function applyExterior(root) {
    metalModels = [];
    var width = settings().mobileImages === false ? 0 : targetWidth();
    var size = width && width < 2600 ? '?width=' + width : '';
    list(root, '[data-model-input]').forEach(function (input) {
      var mask = String(input.dataset.previewEf1 || input.dataset['previewEf-1'] || '');
      if (mask.indexOf(ART + 'ef_mask_1') < 0) return;
      metalModels.push(String(input.dataset.id || ''));
      input.dataset.previewEfHighlights = FILES + 'efx-ext-highlights-v5.png' + size;
      // Colour 1 now also covers the mudguard rim and the lower rail (Reilly, 22 Sep).
      input.dataset.previewEf1 = FILES + 'efx-ext-mask1-v4.png' + size;
      input.setAttribute('data-preview-ef-1', input.dataset.previewEf1);
      input.dataset.previewInitial = FILES + 'efx-ext-start-v3.jpg' + size;
      input.dataset.previewEfFallback = FILES + 'efx-ext-start-v3.jpg' + size;
    });
  }

  function syncTextures(builder) {
    var design = builder.state && builder.state.colourDesign;
    if (!design) return;
    var id = String((builder.state.model && builder.state.model.id) || '');
    var ok = id ? metalModels.indexOf(id) >= 0 : metalModels.length > 0;
    ['colour1', 'colour2'].forEach(function (slot) {
      var colour = design[slot];
      if (!colour || !colour.name) return;
      var name = String(colour.name).toLowerCase();
      var match = list(builder.root, '[data-colour-option][data-colour-target="' + slot + '"]').filter(function (button) {
        return String(button.dataset.name || '').toLowerCase() === name;
      })[0];
      colour.texture = ok && match ? (match.dataset.texture || '') : '';
    });
  }

  // Designs saved before the metallic palette start again on the starting colours.
  function dropUnknownColours(builder) {
    var design = builder.state && builder.state.colourDesign;
    if (!design) return;
    var known = {};
    list(builder.root, '[data-colour-option]').forEach(function (button) {
      known[(button.dataset.colourTarget || '') + '|' + String(button.dataset.name || '').toLowerCase()] = true;
    });
    var stale = ['colour1', 'colour2'].some(function (slot) {
      var colour = design[slot];
      return colour && colour.name && !known[slot + '|' + String(colour.name).toLowerCase()];
    });
    if (!stale) return;
    ['colour1', 'colour2'].forEach(function (slot) { design[slot] = { name: '', ral: '', hex: '', texture: '' }; });
  }

  var INT_VER = '-v2';
  // v3 (22 Sep): rebuilt cabinetry mask (hardware traced, trims anti-aliased), edge-cleaned base, new Bright White render.
  var INT_V3 = { cabinetry: 1 };
  var INTERIOR = { base: 'efx-int-base-v3.jpg', floor: 'efx-int-mask-floor' + INT_VER + '.png', cabinetry: 'efx-int-mask-cabinetry-v3.png', benchtop: 'efx-int-mask-benchtop' + INT_VER + '.png', upholstery: 'efx-int-mask-upholstery' + INT_VER + '.png' };

  function slug(text) { return String(text || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }

  function applyInterior(root) {
    list(root, '[data-model-input]').forEach(function (input) {
      if (input.dataset.previewInteriorBase) return;
      input.dataset.previewInteriorBase = FILES + INTERIOR.base;
      input.dataset.previewInteriorPlaceholder = FILES + INTERIOR.base;
      input.dataset.previewInteriorFloorMask = FILES + INTERIOR.floor;
      input.dataset.previewInteriorCabinetryMask = FILES + INTERIOR.cabinetry;
      input.dataset.previewInteriorBenchtopMask = FILES + INTERIOR.benchtop;
      input.dataset.previewInteriorUpholsteryMask = FILES + INTERIOR.upholstery;
      input.dataset.interiorProfile = 'living_all';
      if (input.dataset.floorRule === 'hidden') input.dataset.floorRule = 'enabled';
      if (input.dataset.upholsteryRule === 'hidden') input.dataset.upholsteryRule = 'enabled';
    });
    list(root, '[data-interior-finish-input]').forEach(function (input) {
      var key = input.dataset.key || '';
      var id = input.dataset.finishCode || input.dataset.finishTitle || input.value || '';
      if (!key || !id || SPRITE_KEYS.indexOf(key + ':' + id) < 0) return;
      input.dataset.previewTexture = FILES + 'efx-int-' + key + '-' + slug(id) + (INT_V3[key] ? '-v3' : INT_VER) + '.jpg';
      var holder = input.closest('label') || input.parentNode;
      var chip = holder && holder.querySelector('[style*="--ef-"]');
      if (chip) spriteBg(chip, key + ':' + id);
    });
  }

  function comboValue(builder, value) {
    var parts = String(value || '').split('|').map(function (part) { return part.trim().toLowerCase(); });
    if (parts.length !== 2 || !parts[0] || !parts[1]) return null;
    var pick = function (name, slot) {
      var match = list(builder.root, '[data-colour-option]').filter(function (button) {
        return String(button.dataset.name || '').trim().toLowerCase() === name &&
          (!button.dataset.colourTarget || button.dataset.colourTarget === slot);
      })[0];
      return match ? { name: match.dataset.name || '', ral: match.dataset.ral || '', hex: match.dataset.hex || '', texture: match.dataset.texture || '' } : null;
    };
    var first = pick(parts[0], 'colour1');
    var second = pick(parts[1], 'colour2');
    return first && second ? [first, second] : null;
  }

  // New visitors start on a real, visibly selected combination (Pearl night blue + White aluminium by default).
  function applyStartingColours(builder) {
    var c = builder.state.colourDesign;
    if ((c.colour1 && c.colour1.name) || (c.colour2 && c.colour2.name)) return false;
    var pair = comboValue(builder, settings().startColours);
    if (!pair) return false;
    c.colour1 = pair[0];
    c.colour2 = pair[1];
    return true;
  }

  /* ---------- exterior / interior toggle on the preview itself ---------- */

  var ICONS = {
    exterior: '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M3 16V8.5A3.5 3.5 0 0 1 6.5 5H16l4 4v7h-2" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M3 16h3m6 0h6M7 8.5h4v3H7z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><circle cx="9" cy="16.5" r="2" fill="none" stroke="currentColor" stroke-width="1.8"/><circle cx="15" cy="16.5" r="2" fill="none" stroke="currentColor" stroke-width="1.8"/></svg>',
    interior: '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M5 11V8a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v3" fill="none" stroke="currentColor" stroke-width="1.8"/><path d="M3 12.5a1.5 1.5 0 0 1 3 0V14h12v-1.5a1.5 1.5 0 0 1 3 0V17a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="M6 18v2m12-2v2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>'
  };

  function modeToggle() {
    var group = document.createElement('div');
    group.className = 'efx-mode';
    group.setAttribute('role', 'group');
    group.setAttribute('aria-label', 'Preview view');
    [['exterior', 'Exterior'], ['interior', 'Interior']].forEach(function (pair, index) {
      var button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('data-preview-mode-button', pair[0]);
      button.setAttribute('aria-pressed', String(index === 0));
      if (index === 0) button.className = 'is-active';
      button.innerHTML = ICONS[pair[0]] + '<span>' + pair[1] + '</span>';
      group.appendChild(button);
    });
    return group;
  }

  function addToggle(wrap) {
    var media = wrap && wrap.querySelector('.ef-preview__media');
    if (media && !media.querySelector('.efx-mode')) media.appendChild(modeToggle());
  }

  // Wide screens: the toggle sits on the preview instead of above it, so the picture keeps its size.
  // Phones: every exterior preview also carries the interior view, so the toggle works from any step.
  function setupPreviewToggles(root) {
    list(root, '.ef-preview-column [data-preview-kind]').forEach(addToggle);
    var source = root.querySelector('.ef-mobile-preview--interior [data-interior-preview-panel]');
    if (!source || has(root, 'efx-no-interior')) return;
    list(root, '.ef-mobile-preview').forEach(function (box) {
      if (box.classList.contains('ef-mobile-preview--interior') || box.querySelector('[data-preview-kind]')) return;
      var exterior = box.querySelector(':scope > [data-preview-panel]');
      if (!exterior) return;
      var outside = document.createElement('div');
      outside.setAttribute('data-preview-kind', 'exterior');
      box.insertBefore(outside, exterior);
      outside.appendChild(exterior);
      var inside = document.createElement('div');
      inside.setAttribute('data-preview-kind', 'interior');
      inside.hidden = true;
      var clone = source.cloneNode(true);
      list(clone, '[id]').forEach(function (element) { element.removeAttribute('id'); });
      inside.appendChild(clone);
      box.appendChild(inside);
      addToggle(outside);
      addToggle(inside);
    });
  }

  /* ---------- state helpers ---------- */

  function interiorAssets(builder) {
    try {
      var panel = builder.root.querySelector('[data-interior-preview-panel]');
      var assets = builder.currentInteriorAssets(panel);
      return !!(assets && (assets.base || assets.placeholder));
    } catch (_) {
      return true;
    }
  }

  function seed(builder) {
    var root = builder.root;
    var input = root.querySelector('[data-model-input]');
    if (!input) return;
    if (String(builder.state.model.id || '') !== String(input.dataset.id || '')) {
      builder.state.model.id = input.dataset.id || '';
      builder.state.model.title = input.dataset.title || '';
    }
    if (has(root, 'efx-skip-pattern')) {
      var ef = efPatternInput(root);
      if (ef && builder.state.colourDesign.pattern !== ef.value) builder.state.colourDesign.pattern = ef.value;
    }
    var steps = builder.activeSteps();
    var first = steps.length ? root.querySelector('[data-config-section="' + steps[0] + '"]') : null;
    var index = first ? Number(first.dataset.stepIndex || 1) : 1;
    if (Number(builder.state.currentStep || 1) < index) builder.state.currentStep = index;
  }

  /* ---------- sending: Shopify's spam check (hCaptcha), no double sends ---------- */

  function nativeSubmit(form) { return HTMLFormElement.prototype.submit.call(form); }

  // Shopify wires hCaptcha to this form on the first tap inside it. Its wrapper gets a token,
  // then calls whatever form.submit was when it wired up. Putting our own submit there first
  // means the token comes back to us and the builder's own send carries it.
  function installSubmitProxy(root) {
    var form = root.querySelector('.ef-form');
    if (!form || form.__efxProxy || form.getAttribute('data-hcaptcha-bound')) return;
    var proxy = function () {
      var waiter = form.__efxWaiter;
      if (waiter) { form.__efxWaiter = null; waiter(); return; }
      if (form.__efxAllowNative) { form.__efxAllowNative = false; nativeSubmit(form); }
    };
    try { form.submit = proxy; } catch (_) { return; }
    if (form.submit === proxy) form.__efxProxy = proxy;
  }

  // hCaptcha's picture puzzle, when it decides to show one.
  function challengeOpen() {
    return list(document, 'iframe[src*="hcaptcha"]').some(function (frame) {
      var box = frame.getBoundingClientRect();
      if (box.width < 150 || box.height < 150) return false;
      for (var node = frame; node && node !== document.documentElement; node = node.parentElement) {
        var style = window.getComputedStyle(node);
        if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) return false;
      }
      return true;
    });
  }

  function captchaToken(builder) {
    var form = builder.form;
    var captcha = window.Shopify && window.Shopify.captcha;
    if (!form || !form.__efxProxy || !captcha || typeof captcha.protect !== 'function') return Promise.resolve('none');
    return new Promise(function (resolve) {
      var settled = false;
      var started = Date.now();
      var poll = 0;
      var waiter = function () { done('token'); };
      var done = function (status) {
        if (settled) return;
        settled = true;
        window.clearInterval(poll);
        if (form.__efxWaiter === waiter) form.__efxWaiter = null;
        resolve(status);
      };
      var run = function () {
        if (settled) return;
        if (form.submit === form.__efxProxy) { done('unbound'); return; }
        form.__efxWaiter = waiter;
        try { form.submit(); } catch (error) { warn(error); done('error'); }
      };
      // Give up waiting (and send anyway) if hCaptcha goes quiet, but never while its puzzle is open.
      poll = window.setInterval(function () {
        var waited = Date.now() - started;
        if (waited > 90000 || (waited > 12000 && !challengeOpen())) done('timeout');
      }, 500);
      if (form.getAttribute('data-hcaptcha-bound')) run();
      else {
        try { captcha.protect(form, run); } catch (error) { warn(error); done('error'); }
      }
    });
  }

  function hashText(text) {
    var h = 2166136261;
    for (var i = 0; i < text.length; i++) { h ^= text.charCodeAt(i); h = Math.imul(h, 16777619); }
    return (h >>> 0).toString(36);
  }

  var SIGNATURE_SKIP = /^(h-captcha-response|g-recaptcha-response|recaptcha-v3-token|form_key|utf8|form_type|contact\[(Configuration reference|Complete configuration|body)\])$/;

  function sendSignature(builder) {
    try { builder.syncHiddenFields(); } catch (_) {}
    var parts = [];
    try {
      new FormData(builder.form).forEach(function (value, key) {
        if (typeof value === 'string' && !SIGNATURE_SKIP.test(key)) parts.push(key + '=' + value);
      });
    } catch (_) {}
    var c = builder.state.customer || {};
    parts.push([c.firstName, c.lastName, c.email, c.phone, c.postcode].join('|'));
    return hashText(parts.join('\n'));
  }

  function alreadySent(builder, signature) {
    if (builder.__efxSentSig === signature) return true;
    var record = stored('localStorage', SENT_KEY);
    return !!(record && record.s === signature && Date.now() - (record.t || 0) < 60 * 864e5);
  }

  function rememberSent(builder, signature) {
    builder.__efxSentSig = signature;
    store('localStorage', SENT_KEY, { s: signature, t: Date.now() });
  }

  function sendNote(builder, text) {
    var root = builder.root;
    var note = root.querySelector('.efx-send-note');
    if (!note) {
      if (!text) return;
      var row = root.querySelector('.ef-submit-row');
      if (!row || !row.parentNode) return;
      note = document.createElement('p');
      note.className = 'efx-send-note';
      note.setAttribute('role', 'status');
      row.parentNode.insertBefore(note, row.nextSibling);
    }
    note.textContent = text || '';
    note.hidden = !text;
  }

  function privacyLine(root, s) {
    if (!s.sendNote || root.querySelector('.efx-privacy')) return;
    var row = root.querySelector('.ef-submit-row');
    if (!row || !row.parentNode) return;
    var line = document.createElement('p');
    line.className = 'efx-privacy';
    line.appendChild(document.createTextNode(s.sendNote));
    if (s.privacyUrl) {
      var link = document.createElement('a');
      link.href = s.privacyUrl;
      link.target = '_blank';
      link.rel = 'noopener';
      link.textContent = 'Privacy policy';
      line.appendChild(document.createTextNode(' '));
      line.appendChild(link);
    }
    row.parentNode.insertBefore(line, row.nextSibling);
  }

  function customerFields(builder) {
    var form = builder.form;
    var c = builder.state.customer || {};
    var values = {
      'contact[First name]': c.firstName || '',
      'contact[Last name]': c.lastName || '',
      'contact[Postcode]': c.postcode || '',
      'contact[name]': [c.firstName, c.lastName].filter(Boolean).join(' '),
      'contact[email]': c.email || '',
      'contact[phone]': c.phone || ''
    };
    Object.keys(values).forEach(function (name) {
      var field = form.elements.namedItem(name);
      if (field && typeof field.length === 'number' && !field.tagName) field = field[0];
      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = name;
        form.appendChild(field);
      }
      if (values[name] && field.value !== values[name]) field.value = values[name];
    });
  }

  // Last resort when Shopify won't take the background send: a normal form send, exactly like
  // the site's other enquiry forms, which also runs Shopify's full-page security check if needed.
  function nativeSend(builder, signature) {
    var form = builder.form;
    if (!form) return false;
    try { builder.ensureConfigurationReference(); builder.syncHiddenFields(); } catch (_) {}
    customerFields(builder);
    store('sessionStorage', NATIVE_KEY, { s: signature, t: Date.now() });
    try { builder.flushSave(); } catch (_) {}
    builder.hideActionFeedback();
    sendNote(builder, 'Almost there. Finishing the send\u2026');
    builder.setButtonsLoading('[data-submit]', true, SEND_BUSY);
    track('ef_configuration_fallback', {});
    form.__efxAllowNative = true;
    try {
      if (form.getAttribute('data-hcaptcha-bound') && form.submit !== form.__efxProxy) {
        // Shopify's wrapper ignores a second call within 250 ms of the last one.
        window.setTimeout(function () {
          try { form.submit(); } catch (error) { warn(error); }
        }, 300);
        // No answer from hCaptcha: send it plainly and let Shopify show its own security check page.
        var started = Date.now();
        var poll = window.setInterval(function () {
          if (!form.__efxAllowNative) { window.clearInterval(poll); return; }
          var waited = Date.now() - started;
          if (waited < 90000 && (waited < 15000 || challengeOpen())) return;
          window.clearInterval(poll);
          form.__efxAllowNative = false;
          nativeSubmit(form);
        }, 500);
      } else {
        form.__efxAllowNative = false;
        nativeSubmit(form);
      }
      return true;
    } catch (error) {
      warn(error);
      form.__efxAllowNative = false;
      builder.setButtonsLoading('[data-submit]', false, SEND_BUSY);
      sendNote(builder, '');
      return false;
    }
  }

  function whenLeadTrackingReady(callback) {
    var start = Date.now();
    (function check() {
      if (window.__efLeadTrackingLoaded || Date.now() - start > 8000) { window.setTimeout(callback, 80); return; }
      window.setTimeout(check, 150);
    })();
  }

  // Back from a normal form send (the fallback above).
  function handleReturn(builder) {
    var params;
    try { params = new URLSearchParams(window.location.search); } catch (_) { return; }
    var pending = stored('sessionStorage', NATIVE_KEY);
    var posted = params.get('contact_posted') === 'true';
    if (posted) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.delete('contact_posted');
        window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
      } catch (_) {}
    }
    if (!pending) return;
    store('sessionStorage', NATIVE_KEY, null);
    if (posted) {
      builder.submittedSuccessfully = true;
      if (pending.s) rememberSent(builder, pending.s);
      whenLeadTrackingReady(function () {
        var panel = builder.root.querySelector('[data-send-result]');
        if (panel) {
          panel.hidden = false;
          try { panel.focus({ preventScroll: true }); } catch (_) {}
          try { panel.scrollIntoView({ block: 'center' }); } catch (_) {}
        }
        try { builder.announce('Your configuration has been sent to EuroFloat.'); } catch (_) {}
        track('ef_configuration_sent', { method: 'form' });
      });
    } else if (params.get('form_key') || params.get('form_type')) {
      sendNote(builder, 'Security check done. Tap Send Configuration again to finish sending your design.');
      try { builder.scrollTo('review'); } catch (_) {}
    }
  }

  /* ---------- design links (carry a design into another browser) ---------- */

  function encodeDesign(design) {
    var json = JSON.stringify(design);
    return window.btoa(unescape(encodeURIComponent(json))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  function decodeDesign(value) {
    try {
      var b64 = String(value).replace(/-/g, '+').replace(/_/g, '/');
      while (b64.length % 4) b64 += '=';
      return JSON.parse(decodeURIComponent(escape(window.atob(b64))));
    } catch (_) {
      return null;
    }
  }

  function designOf(builder) {
    var s = builder.state;
    var c = s.colourDesign;
    var pick = function (source, keys) {
      var out = {};
      keys.forEach(function (key) { if (source && source[key]) out[key] = source[key]; });
      return out;
    };
    return {
      v: 1,
      m: s.model.id || '',
      c: {
        p: c.pattern || '',
        a: c.colour1.name ? { n: c.colour1.name, r: c.colour1.ral } : null,
        b: c.colour2.name ? { n: c.colour2.name, r: c.colour2.ral } : null,
        k: c.checkerPlate || '',
        t: c.tackBox || '',
        x: c.bbqBox || '',
        o: c.otherRal && c.otherRal.enabled ? { c: c.otherRal.code, n: c.otherRal.name, x: c.otherRal.notes } : null
      },
      p: s.package.type || '',
      h: pick(s.horseArea, ['bayDirection', 'divider', 'beds']),
      i: pick(s.interior, ['floor', 'cabinetry', 'benchtop', 'upholstery'])
    };
  }

  function designUrl(builder) {
    var url = new URL(window.location.href);
    url.searchParams.set(PARAM, encodeDesign(designOf(builder)));
    url.hash = '';
    return url.toString();
  }

  function setDesignParam(builder) {
    try {
      window.history.replaceState(window.history.state, '', designUrl(builder));
      builder.__efxLinkInUrl = true;
    } catch (_) {}
  }

  function cleanUrl() {
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has(PARAM)) return;
      url.searchParams.delete(PARAM);
      window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    } catch (_) {}
  }

  function matchingValue(root, group, key, value) {
    if (typeof value !== 'string' || !value) return '';
    return list(root, '[data-group="' + group + '"][data-key="' + key + '"]').some(function (input) { return input.value === value; }) ? value : '';
  }

  function readDesignLink(builder) {
    var raw = null;
    try { raw = new URLSearchParams(window.location.search).get(PARAM); } catch (_) { return; }
    if (!raw) return;
    cleanUrl();
    var d = decodeDesign(raw);
    if (!d || d.v !== 1) return;
    var root = builder.root;
    var state = builder.state;
    var c = d.c || {};
    if (d.m && list(root, '[data-model-input]').some(function (input) { return input.dataset.id === d.m; })) {
      state.model.id = str(d.m);
      state.model.title = '';
    }
    var pattern = matchingValue(root, 'colourDesign', 'pattern', c.p);
    if (pattern) state.colourDesign.pattern = pattern;
    [['colour1', c.a], ['colour2', c.b]].forEach(function (pair) {
      var slot = pair[0];
      var chosen = pair[1];
      if (!chosen || !chosen.n) return;
      var button = list(root, '[data-colour-option]').filter(function (candidate) {
        return candidate.dataset.name === chosen.n && (!chosen.r || candidate.dataset.ral === chosen.r) &&
          (!candidate.dataset.colourTarget || candidate.dataset.colourTarget === slot);
      })[0];
      if (button) {
        state.colourDesign[slot] = { name: button.dataset.name || '', ral: button.dataset.ral || '', hex: button.dataset.hex || '', texture: button.dataset.texture || '' };
      }
    });
    [['checkerPlate', c.k], ['tackBox', c.t], ['bbqBox', c.x]].forEach(function (pair) {
      var value = matchingValue(root, 'colourDesign', pair[0], pair[1]);
      if (value) state.colourDesign[pair[0]] = value;
    });
    if (c.o && typeof c.o === 'object') {
      state.colourDesign.otherRal = { enabled: true, code: str(c.o.c, 40), name: str(c.o.n, 60), notes: str(c.o.x, 200) };
    }
    if (typeof d.p === 'string' && list(root, '[data-package-input]').some(function (input) { return input.value === d.p; })) {
      state.package.type = d.p;
    }
    ['bayDirection', 'divider', 'beds'].forEach(function (key) {
      var value = matchingValue(root, 'horseArea', key, d.h && d.h[key]);
      if (value) state.horseArea[key] = value;
    });
    ['floor', 'cabinetry', 'benchtop', 'upholstery'].forEach(function (key) {
      var value = matchingValue(root, 'interior', key, d.i && d.i[key]);
      if (value) state.interior[key] = value;
    });
    builder.__efxFromLink = true;
  }

  /* ---------- PDF in app browsers (Facebook, Instagram ...) ---------- */

  function pdfName(builder) {
    var model = String(builder.state.model.title || 'EuroFloat').replace(/[^a-z0-9]+/gi, '-').replace(/^-|-$/g, '');
    var date = typeof builder.localDate === 'function' ? builder.localDate() : new Date().toISOString().slice(0, 10);
    return 'EuroFloat-' + model + '-Configuration-' + date + '.pdf';
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText && window.isSecureContext) {
      return navigator.clipboard.writeText(text).then(function () { return true; }, function () { return legacyCopy(text); });
    }
    return Promise.resolve(legacyCopy(text));
  }

  function legacyCopy(text) {
    var area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.cssText = 'position:fixed;top:0;left:0;opacity:0;pointer-events:none';
    document.body.appendChild(area);
    area.select();
    try { area.setSelectionRange(0, text.length); } catch (_) {}
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (_) {}
    area.remove();
    return ok;
  }

  function pdfPanel(builder) {
    var root = builder.root;
    var panel = root.querySelector('.efx-pdf-panel');
    if (panel) return panel;
    panel = document.createElement('section');
    panel.className = 'ef-action-feedback ef-action-feedback--download efx-pdf-panel';
    panel.hidden = true;
    panel.tabIndex = -1;
    panel.setAttribute('aria-live', 'polite');
    var icon = root.querySelector('[data-download-result] .ef-action-feedback__icon');
    var iconNode = icon ? icon.cloneNode(true) : document.createElement('span');
    iconNode.className = 'ef-action-feedback__icon';
    iconNode.setAttribute('aria-hidden', 'true');
    var copy = document.createElement('div');
    copy.className = 'ef-action-feedback__copy';
    copy.innerHTML = '<strong>Your PDF is ready.</strong><p data-efx-pdf-text></p>' +
      '<div class="ef-action-feedback__actions">' +
      '<button type="button" class="ef-button ef-button--primary" data-efx-pdf-open></button>' +
      '<button type="button" class="ef-button ef-button--secondary" data-efx-copy-link>Copy link to my design</button>' +
      '</div><p class="efx-pdf-tip" data-efx-pdf-tip></p>';
    panel.appendChild(iconNode);
    panel.appendChild(copy);
    var anchor = root.querySelector('[data-download-result]') || root.querySelector('.ef-submit-row');
    if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(panel, anchor.nextSibling);
    else root.appendChild(panel);
    return panel;
  }

  function showPdf(builder, blob) {
    var panel = pdfPanel(builder);
    var name = pdfName(builder);
    var file = null;
    try { file = new File([blob], name, { type: 'application/pdf' }); } catch (_) {}
    var canShare = false;
    try { canShare = !!(file && navigator.share && navigator.canShare && navigator.canShare({ files: [file] })); } catch (_) {}
    var openButton = panel.querySelector('[data-efx-pdf-open]');
    var copyButton = panel.querySelector('[data-efx-copy-link]');
    panel.querySelector('[data-efx-pdf-text]').textContent = canShare
      ? 'Save it to your phone, or send it to yourself or someone else.'
      : 'Open it now, then use your phone\u2019s share button to save or send it.';
    panel.querySelector('[data-efx-pdf-tip]').textContent = 'Using Facebook or Instagram? If the PDF doesn\u2019t open, tap \u2022\u2022\u2022 or \u22EE at the top of your screen and choose \u201COpen in browser\u201D (or Safari/Chrome), then tap Download again. Your design comes with you.';
    openButton.textContent = canShare ? 'Save or share PDF' : 'Open PDF';
    openButton.onclick = function () {
      if (canShare) {
        navigator.share({ files: [file], title: 'My EuroFloat design' }).then(function () {
          track('ef_pdf_download', { method: 'share' });
        }).catch(function () {});
        return;
      }
      var url = URL.createObjectURL(blob);
      var opened = null;
      try { opened = window.open(url, '_blank'); } catch (_) {}
      if (!opened) window.location.href = url;
      track('ef_pdf_download', { method: 'open' });
    };
    copyButton.onclick = function () {
      var label = 'Copy link to my design';
      copyText(designUrl(builder)).then(function (ok) {
        copyButton.textContent = ok ? 'Link copied' : 'Copy failed. Try again';
        window.setTimeout(function () { copyButton.textContent = label; }, 2400);
        if (ok) track('ef_design_link_copy', {});
      });
    };
    setDesignParam(builder);
    var result = builder.root.querySelector('[data-download-result]');
    if (result) result.hidden = false;
    panel.hidden = false;
    try { panel.focus({ preventScroll: true }); } catch (_) {}
    try { panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (_) {}
    track('ef_pdf_ready', { method: 'in_app' });
  }

  function inAppDownload(builder) {
    if (builder.downloadInFlight || !builder.validateConfiguration()) return Promise.resolve();
    builder.downloadInFlight = true;
    builder.hideActionFeedback();
    pdfPanel(builder).hidden = true;
    builder.setButtonsLoading('[data-download]', true, PDF_BUSY);
    return Promise.resolve().then(function () {
      return builder.composeExteriorImage();
    }).then(function (exterior) {
      return Promise.resolve(builder.composeInteriorImage()).then(function (interior) {
        return builder.createConfigurationPdf(exterior, interior);
      });
    }).then(function (blob) {
      if (!blob || blob.size < 1000) throw new Error('The PDF file was not generated correctly.');
      showPdf(builder, blob);
    }).catch(function (error) {
      console.error('EuroFloat PDF generation error:', error);
      builder.showActionError('The PDF could not be created.', error && error.message ? error.message : 'Your selections have been preserved. Please try the download again.');
    }).then(function () {
      builder.downloadInFlight = false;
      builder.setButtonsLoading('[data-download]', false, PDF_BUSY);
    });
  }

  /* ---------- preview: smooth first load ---------- */

  function showVeilFallback(builder) {
    var url = builder.__efxVeilFallback;
    if (!url) return;
    list(builder.root, '[data-preview-panel]').forEach(function (panel) {
      var base = panel.querySelector('[data-preview-base]');
      var image = panel.querySelector('[data-preview-fallback]');
      if (!base || base.hidden || !base.getAttribute('src') || !image || !image.hidden) return;
      image.src = url;
      image.hidden = false;
      image.dataset.efxVeil = '1';
    });
  }

  function lift(root) {
    if (!root || !has(root, 'efx-loading')) return;
    root.classList.remove('efx-loading');
    window.setTimeout(function () {
      list(root, '[data-preview-fallback][data-efx-veil]').forEach(function (image) {
        delete image.dataset.efxVeil;
        if (image.dataset.currentUrl) return;
        image.hidden = true;
        image.removeAttribute('src');
      });
    }, 500);
  }

  function loadImage(url) {
    return new Promise(function (resolve) {
      var image = new Image();
      image.decoding = 'async';
      image.onload = function () { (image.decode ? image.decode() : Promise.resolve()).then(resolve, resolve); };
      image.onerror = resolve;
      image.src = url;
    });
  }

  // Resolves once the image shows its current src: waits again if the src changes while loading.
  function settled(image) {
    return new Promise(function (resolve) {
      var tries = 0;
      var check = function () {
        if (++tries > 6) return resolve();
        if (image.complete) {
          if (!image.naturalWidth) return resolve();
          var src = image.currentSrc || image.src;
          (image.decode ? image.decode() : Promise.resolve()).then(function () {
            if ((image.currentSrc || image.src) === src) resolve(); else check();
          }, function () { window.setTimeout(check, 60); });
          return;
        }
        var done = function () { image.removeEventListener('load', done); image.removeEventListener('error', done); window.setTimeout(check, 0); };
        image.addEventListener('load', done);
        image.addEventListener('error', done);
      };
      check();
    });
  }

  function veil(builder) {
    var root = builder.root;
    var assets = builder.currentPatternAssets();
    if (!builder.state.colourDesign.pattern || !assets.base || !assets.mask1 || !assets.mask2) return;
    var panels = list(root, '[data-preview-panel]').filter(function (panel) {
      var base = panel.querySelector('[data-preview-base]');
      return !!(base && !base.hidden && base.getAttribute('src'));
    });
    if (!panels.length) return;
    root.classList.add('efx-loading');
    // The loading photo is the start colours: show it only when those are the colours on screen.
    var start = String(settings().startColours || '').toLowerCase().split('|').map(function (part) { return part.trim(); });
    var c = builder.state.colourDesign || {};
    var same = start.length === 2 && c.colour1 && c.colour2 &&
      String(c.colour1.name || '').trim().toLowerCase() === start[0] && String(c.colour2.name || '').trim().toLowerCase() === start[1];
    builder.__efxVeilFallback = same ? (assets.fallback || '') : '';
    showVeilFallback(builder);
    var waits = [];
    panels.forEach(function (panel) {
      ['[data-preview-base]', '[data-preview-highlights]'].forEach(function (selector) {
        var image = panel.querySelector(selector);
        if (!image || !image.getAttribute('src')) return;
        waits.push(settled(image));
      });
      list(panel, '.ef-preview__paint').forEach(function (layer) {
        var match = /url\(["']?([^"')]+)["']?\)/.exec(window.getComputedStyle(layer).backgroundImage || '');
        if (match) waits.push(loadImage(match[1]));
      });
    });
    [assets.mask1, assets.mask2, assets.checkerMask, assets.logo1, assets.logo2].filter(Boolean).forEach(function (url) {
      waits.push(loadImage(url));
    });
    var finish = function () { lift(root); };
    window.setTimeout(finish, 8000);
    Promise.all(waits).then(function () {
      if (window.requestAnimationFrame) window.requestAnimationFrame(finish);
      window.setTimeout(finish, 120);
    });
  }

  // --efx-title-h: the product title row that scrolls away; --efx-pin-h: what stays pinned (the steps).
  function trackBarHeight(root) {
    var bar = root.querySelector('.ef-product-bar');
    if (!bar) return;
    var title = bar.querySelector('.ef-product-bar__inner');
    var headerBottom = function () {
      var bottom = 0;
      list(document, '.shopify-section-group-header-group, header, sticky-header, .header-wrapper').forEach(function (element) {
        if (root.contains(element)) return;
        var style = window.getComputedStyle(element);
        if (style.position !== 'sticky' && style.position !== 'fixed') return;
        var rect = element.getBoundingClientRect();
        if (rect.height > 0 && rect.top < 240 && rect.bottom > 0) bottom = Math.max(bottom, rect.bottom);
      });
      return Math.round(bottom);
    };
    var lastTop = -1;
    var lastPad = -1;
    var setTop = function () {
      var top = headerBottom();
      if (top !== lastTop) { lastTop = top; root.style.setProperty('--efx-top', top + 'px'); }
      // The theme already offsets anchor scrolls (scroll-padding-top on <html>); count it once.
      var pad = Math.round(parseFloat(window.getComputedStyle(document.documentElement).scrollPaddingTop) || 0);
      if (pad !== lastPad) { lastPad = pad; root.style.setProperty('--efx-sp', pad + 'px'); }
    };
    var set = function () {
      setTop();
      var barHeight = Math.round(bar.getBoundingClientRect().height);
      var titleHeight = title && has(root, 'efx-scroll-title') ? Math.round(title.getBoundingClientRect().height) : 0;
      root.style.setProperty('--efx-bar-h', barHeight + 'px');
      root.style.setProperty('--efx-title-h', titleHeight + 'px');
      root.style.setProperty('--efx-pin-h', Math.max(0, barHeight - titleHeight) + 'px');
    };
    set();
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; setTop(); });
    }, { passive: true });
    window.addEventListener('resize', setTop, { passive: true });
    if (window.ResizeObserver) {
      var observer = new ResizeObserver(set);
      observer.observe(bar);
      if (title) observer.observe(title);
    } else {
      window.addEventListener('resize', set, { passive: true });
    }
  }

  /* ---------- builder patches (prototype, applied once) ---------- */

  function patch(Builder) {
    var P = Builder && Builder.prototype;
    if (!P) throw new Error('Builder class missing');
    if (P.__efx) return;
    var names = ['restore', 'reconcileRangeSelection', 'activeSteps', 'scrollTo', 'clearConfiguration', 'setPreviewMode', 'selectColour', 'applyCombination', 'queueSave', 'handleDownload', 'composeInteriorImage', 'createConfigurationPdf', 'sendConfiguration', 'currentPatternAssets', 'currentInteriorAssets', 'renderPreview', 'extractSubmissionError', 'validateAll', 'syncHiddenFields', 'syncCustomerFromVisibleInputs', 'setButtonsLoading', 'hideActionFeedback', 'ensureConfigurationReference', 'flushSave', 'queueAutomaticPreview', 'renderAll'];
    var o = {};
    names.forEach(function (name) {
      if (typeof P[name] !== 'function') throw new Error('Builder method missing: ' + name);
      o[name] = P[name];
    });

    // Optional patches (skipped quietly if the builder changes).
    // Scroll spy: the section under the pinned steps bar is the current one. The builder's
    // IntersectionObserver band sits under the theme header on this site and lags a section or more.
    if (typeof P.setupSectionObserver === 'function' && typeof P.setCurrentAnchor === 'function') {
      var oSetup = P.setupSectionObserver;
      P.setupSectionObserver = function () {
        var result = oSetup.apply(this, arguments);
        var self = this;
        try {
          if (self.observer && self.observer.disconnect) self.observer.disconnect();
          var bar = self.root.querySelector('.ef-product-bar');
          var last = '';
          var pick = function () {
            var sections = list(self.root, '[data-config-section]').filter(function (section) {
              return !section.hidden && section.offsetParent !== null && !has(section, 'is-locked');
            });
            if (!sections.length) return;
            var pinned = bar ? Math.max(0, bar.getBoundingClientRect().bottom) : 0;
            var line = pinned + Math.max(56, 0.3 * ((window.innerHeight || 800) - pinned));
            var current = '';
            sections.forEach(function (section) { if (section.getBoundingClientRect().top <= line) current = section.dataset.configSection; });
            if (!current) current = sections[0].dataset.configSection;
            var doc = document.documentElement;
            if (window.innerHeight + window.pageYOffset >= doc.scrollHeight - 4) current = sections[sections.length - 1].dataset.configSection;
            if (current && current !== last) { last = current; self.setCurrentAnchor(current); }
          };
          var ticking = false;
          window.addEventListener('scroll', function () {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(function () { ticking = false; try { pick(); } catch (error) { warn(error); } });
          }, { passive: true });
          window.addEventListener('resize', function () { try { pick(); } catch (error) { warn(error); } }, { passive: true });
          window.setTimeout(function () { try { pick(); } catch (error) { warn(error); } }, 300);
        } catch (error) { warn(error); }
        return result;
      };
    }

    // Phones: every visible section keeps its own preview up to date, so a section is never
    // shown with an empty placeholder when the customer scrolls or jumps ahead.
    if (typeof P.panelIsRelevant === 'function') {
      var oRelevant = P.panelIsRelevant;
      P.panelIsRelevant = function (panel) {
        if (oRelevant.apply(this, arguments)) return true;
        var mobile = window.matchMedia && window.matchMedia('(max-width: 899px)').matches;
        if (!mobile || !panel || !panel.closest('.ef-mobile-preview')) return false;
        var section = panel.closest('[data-config-section]');
        return !!section && !section.hidden && section.offsetParent !== null;
      };
    }

    P.restore = function () {
      var result = o.restore.apply(this, arguments);
      try { readDesignLink(this); } catch (error) { warn(error); }
      try { dropUnknownColours(this); } catch (error) { warn(error); }
      try { applyStartingColours(this); } catch (error) { warn(error); }
      return result;
    };

    P.reconcileRangeSelection = function () {
      if (has(this.root, 'efx-single')) { try { seed(this); } catch (error) { warn(error); } }
      return o.reconcileRangeSelection.apply(this, arguments);
    };

    P.activeSteps = function () {
      var steps = o.activeSteps.apply(this, arguments);
      var root = this.root;
      if (has(root, 'efx-single')) steps = steps.filter(function (name) { return name !== 'model'; });
      if (has(root, 'efx-skip-pattern')) steps = steps.filter(function (name) { return name !== 'pattern'; });
      return steps;
    };

    P.scrollTo = function (name) {
      var args = Array.prototype.slice.call(arguments);
      if (name === 'model' || name === 'pattern') {
        var steps = this.activeSteps();
        if (steps.indexOf(name) < 0 && steps.length) args[0] = steps[0];
      }
      return o.scrollTo.apply(this, args);
    };

    P.clearConfiguration = function () {
      var result = o.clearConfiguration.apply(this, arguments);
      var changed = false;
      try {
        if (has(this.root, 'efx-single') && !this.state.model.id) { this.reconcileRangeSelection(); changed = true; }
        if (applyStartingColours(this)) changed = true;
        if (changed) this.renderAll();
      } catch (error) { warn(error); }
      return result;
    };

    // Steady preview: scrolling never flips the picture. It changes when the customer taps
    // Exterior/Interior or changes that part, plus once, the first time a wide screen reaches Interior.
    P.queueAutomaticPreview = function (sectionName) {
      if (settings().steadyPreview === false) return o.queueAutomaticPreview.apply(this, arguments);
      if (sectionName !== 'interior' || this.__efxInteriorShown) return;
      if (window.matchMedia && window.matchMedia('(max-width: 899px)').matches) return;
      if (!interiorAssets(this)) return;
      this.__efxInteriorShown = true;
      if (this.__efxManualMode || this.previewMode === 'interior') return;
      return o.queueAutomaticPreview.apply(this, arguments);
    };

    P.setPreviewMode = function (mode) {
      var args = Array.prototype.slice.call(arguments);
      if (mode === 'interior' && !interiorAssets(this)) args[0] = 'exterior';
      return o.setPreviewMode.apply(this, args);
    };

    P.renderPreview = function () {
      try { syncTextures(this); } catch (error) { warn(error); }
      var result = o.renderPreview.apply(this, arguments);
      if (has(this.root, 'efx-loading')) { try { showVeilFallback(this); } catch (error) { warn(error); } }
      return result;
    };

    P.selectColour = function (button) {
      var slot = button && (button.dataset.colourTarget === 'colour1' || button.dataset.colourTarget === 'colour2') ? button.dataset.colourTarget : this.activeColourSlot;
      var result = o.selectColour.apply(this, arguments);
      lift(this.root);
      if (button) track('ef_colour_select', { colour_slot: slot === 'colour2' ? 'colour_2' : 'colour_1', colour_name: button.dataset.name || '', colour_ral: button.dataset.ral || '' });
      return result;
    };

    P.applyCombination = function (value) {
      var result = o.applyCombination.apply(this, arguments);
      lift(this.root);
      track('ef_combination_select', { combination: String(value || '').split('|').join(' + ') });
      return result;
    };

    P.queueSave = function () {
      var result = o.queueSave.apply(this, arguments);
      if (this.__efxLinkInUrl) { this.__efxLinkInUrl = false; cleanUrl(); }
      return result;
    };

    P.composeInteriorImage = function () {
      if (this.hasInteriorStep() && !interiorAssets(this)) return Promise.resolve('');
      return o.composeInteriorImage.apply(this, arguments);
    };

    P.createConfigurationPdf = function (exterior, interior) {
      try { syncTextures(this); } catch (error) { warn(error); }
      if (interior || interiorAssets(this)) return o.createConfigurationPdf.apply(this, arguments);
      var self = this;
      var own = Object.prototype.hasOwnProperty.call(self, 'hasInteriorStep');
      var previous = self.hasInteriorStep;
      self.hasInteriorStep = function () { return false; };
      try {
        return o.createConfigurationPdf.apply(self, arguments);
      } finally {
        if (own) self.hasInteriorStep = previous;
        else delete self.hasInteriorStep;
      }
    };

    P.handleDownload = function () {
      try { syncTextures(this); } catch (error) { warn(error); }
      if (IN_APP) return inAppDownload(this);
      var self = this;
      var result = self.root.querySelector('[data-download-result]');
      if (result) result.hidden = true;
      return Promise.resolve(o.handleDownload.apply(self, arguments)).then(function (value) {
        if (result && !result.hidden) track('ef_pdf_download', { method: 'download' });
        return value;
      });
    };

    P.extractSubmissionError = function (documentNode, response) {
      var message = o.extractSubmissionError.apply(this, arguments);
      if (response && /\/challenge|captcha/i.test(response.url || '')) this.__efxChallenge = true;
      return message;
    };

    P.sendConfiguration = function () {
      var self = this;
      var args = arguments;
      var sentEvent = function (method) {
        track('ef_configuration_sent', {
          method: method,
          colour_1: self.state.colourDesign.colour1.name || '',
          colour_2: self.state.colourDesign.colour2.name || '',
          package_type: self.state.package.type || ''
        });
      };
      if (settings().reliableSend === false || !self.form) {
        var before = !!self.submittedSuccessfully;
        return Promise.resolve(o.sendConfiguration.apply(self, args)).then(function (value) {
          if (!before && self.submittedSuccessfully) sentEvent('background');
          return value;
        });
      }
      if (self.submissionInFlight || self.__efxSending) return Promise.resolve();
      try { self.syncCustomerFromVisibleInputs(); } catch (_) {}
      if (!self.validateAll()) return Promise.resolve();
      sendNote(self, '');
      var signature = sendSignature(self);
      if (alreadySent(self, signature)) {
        sendNote(self, 'This design has already been sent to EuroFloat. Change anything and you can send it again.');
        try { self.announce('This design has already been sent to EuroFloat.'); } catch (_) {}
        return Promise.resolve();
      }
      self.__efxSending = true;
      self.hideActionFeedback();
      self.setButtonsLoading('[data-submit]', true, SEND_BUSY);
      return captchaToken(self).then(function (status) {
        self.__efxCaptcha = status;
        self.__efxChallenge = false;
        self.__efxSending = false;
        self.submittedSuccessfully = false;
        self.setButtonsLoading('[data-submit]', false, SEND_BUSY);
        return o.sendConfiguration.apply(self, args);
      }).then(function (value) {
        if (self.submittedSuccessfully) {
          rememberSent(self, signature);
          sentEvent('background');
        } else if (self.__efxChallenge) {
          self.__efxChallenge = false;
          nativeSend(self, signature);
        }
        return value;
      }, function (error) {
        self.__efxSending = false;
        try { self.setButtonsLoading('[data-submit]', false, SEND_BUSY); } catch (_) {}
        warn(error);
      });
    };

    P.__efx = true;
  }

  function afterInit(builder) {
    var root = builder.root;
    trackBarHeight(root);
    veil(builder);
    root.addEventListener('click', function (event) {
      if (event.target && event.target.closest && event.target.closest('[data-preview-mode-button]')) builder.__efxManualMode = true;
    }, true);
    if (settings().reliableSend !== false) { try { handleReturn(builder); } catch (error) { warn(error); } }
    if (builder.__efxFromLink) {
      builder.__efxFromLink = false;
      builder.queueSave();
      track('ef_design_link_open', {});
    }
  }

  function hook(root, Builder) {
    var patched = false;
    try { patch(Builder); patched = true; } catch (error) { warn(error); }
    if (patched) {
      try { prepare(root); } catch (error) { warn(error); }
    } else {
      document.documentElement.classList.remove('efx-js');
    }
    var builder = new Builder(root);
    if (patched) { try { afterInit(builder); } catch (error) { warn(error); } }
    return builder;
  }
  hook.efx = true;
  window.efBuilderHook = hook;
})();
